import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Modal from 'react-modal';
import { MdHistory, MdEdit } from 'react-icons/lib/md';
import _ from 'lodash';
import { mediumModalStyle } from '../../constants';
import { fetchPermissions } from '../../actions/project_actions';
import { fetchCSBDetails } from '../../actions/additional_actions';
import { withAuth } from '../../actions/';
import ReadOnlyCSBDetails from './ReadOnlyCSBDetails';
import CSBDetailsForm from './CSBDetailsForm';
import { getDateValue } from '../../utils/date';
import { MdList } from 'react-icons/lib/md';

class CSBContractDetails extends Component {

    // static PropTypes = {
    //     csbDetail: PropTypes.array.isRequired,
    //     permissions: PropTypes.object.isRequired,
    // }

    constructor(props) {
        super(props);
        this.state = {
            contract: {},
            isEditable: false,
            isLoading: false,
            logsList: [],
        }
        this.handleSubmit = this.handleSubmit.bind(this);
        this.toggleEditable = this.toggleEditable.bind(this);
        this.showLog = this.showLog.bind(this);
        this.onDone = this.onDone.bind(this);
        this.handleLog = this.handleLog.bind(this);
    }

    UNSAFE_componentWillMount() {
        const { contract } = this.props;
        this.props.fetchCSBDetails(contract.projectId, contract.contractId);
        this.props.fetchPermissions(contract.projectId);

    }

    componentDidUpdate(prevProps) {
        if (prevProps.contract.contractId !== this.props.contract.contractId) {
            this.props.fetchCSBDetails(this.props.contract.projectId, this.props.contract.contractId);
            this.props.fetchPermissions(this.props.contract.projectId);
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.csbDetail !== nextProps.csbDetail)
            this.setState({ csbDetail: nextProps.csbDetail })
        if (this.props.contract.contractId !== nextProps.contract.contractId)
            this.setState({ contract: nextProps.contract })
    }

    showLog() {
        this.handleLog();

    }

    onDone() {
        this.setState({ modalVisible: false });
    }

    toggleEditable() {
        this.setState({ isEditable: !this.state.isEditable });
    }

    handleSubmit(csbDetail) {
        const url = `/projects/${csbDetail.projectId}/csbDetails/${csbDetail.contractId}`;
        return withAuth(
            { method: 'post', url: url, data: csbDetail },
            () => {
                this.toggleEditable();
                this.props.saveInfo(csbDetail);
                this.setState({ isLoading: false });
            }
        );
    }
    handleLog() {

        const projectId = this.props.contract.projectId;
        const cntrctId = this.props.contract.contractId;

        let url = `projects/${projectId}/csbDetailsLog/${cntrctId}`;
        let method = 'get';


        return withAuth(
            { method, url },
            (response) => {
                var data = response.data;
                this.setState({ modalVisible: true, logsList: data.entries });
            },
            this.errorHandler
        )
    }

    renderTable(logsList) {
        return (
            <div className="dw-table">
                <table className="table-striped">
                    <thead>
                        <tr>
                            <th>Revised NTP Date</th>
                            {/* <th>Comments</th> */}
                            <th>Created By</th>
                            <th>Created Date</th>
                            <th>Modified By</th>
                            <th>Modified Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {_.orderBy(logsList, ['createdDate'], ['desc']).map(log =>
                            <tr key={log.id}>
                                <td>{getDateValue(log.revisedNTPDt)}</td>
                                {/* <td>{log.comments}</td> */}
                                <td>{log.createdBy}</td>
                                <td>{getDateValue(log.createdDt)}</td>
                                <td>{log.modifiedBy}</td>
                                <td>{getDateValue(log.modifiedDt)}</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        )
    }

    render() {
    
        const { csbDetail, permissions } = this.props;
        const { contract } = this.props;
        const { isEditable, isLoading } = this.state;

        const { roleModules } = permissions.editPrivileges;

        const canShowForm = roleModules !== null && roleModules.includes('Project Info') && isEditable && !isLoading
            ? true : false;
        const canShowButtons = roleModules !== null && roleModules.includes('Project Info') && this.props.contract.contractStatus === 'Active Contract' && !isLoading
            ? true : false;

        const className = 'row-wide project-info' + (isEditable ? ' editable' : '');

        return (
            <div>

                {this.state.modalVisible
                    && <Modal
                        isOpen={this.state.modalVisible}
                        style={mediumModalStyle}
                        contentLabel="Status Log"
                    >
                        <div className="col s12">
                            <h1 className="bar-bottom header">Contract Details Log</h1></div>

                        <div className="modal-form logmodal">
                            <div className="project-detail-comments">
                                <div className="col s12">
                                    {this.state.logsList.length
                                        ? this.renderTable(this.state.logsList)
                                        : <div>This record has no logs yet.</div>}
                                </div>
                            </div>
                        </div>
                        <div className="modal-close" onClick={this.onDone}>
                            <span className="close"></span>
                        </div>
                    </Modal>
                }

                {csbDetail.length > 0 ?

                    <div id="accordiondetails" className="row-wide">
                        {/* <div className="col s12">
                     <h4 className="bar-bottom header"><MdDescription size={32} color='#8492a6' />Contract Details for {this.props.contract.regNumber} - {this.props.contract.contractType}

                     </h4>
                 </div> */}
                    </div> : null}
                {csbDetail.length > 0 ?
                    <div id="info" className={className}>
                        {csbDetail.length > 0 && contract.divisionName === 'Infrastructure' ?
                            <div >
                                <h4 className="bar-bottom header margin-bottom-175 detailicons">
                                    {csbDetail.length > 0 ?
                                        <div id="info" className={className}>
                                            {canShowButtons && csbDetail.length > 0 && contract.divisionName === 'Infrastructure' ?
                                                <div >
                                                    <span className='margin-right-0325' id='greyColor'><MdList className="fa-Icon" size={20} /></span>
                                                    Contract Details
                                                    <span className='fa-Icon-History edit-hidden' onClick={() => this.showLog()}><MdHistory size={22} color='#8492a6' /></span>
                                                    <span className='fa-Icon-Edit' onClick={this.toggleEditable}><MdEdit size={22} color='#8492a6' /></span>
                                                </div>
                                                : <div><span className='margin-right-0325' id='greyColor'><MdList className="fa-Icon" size={20} /></span>
                                                    Contract Details </div> }
                                        </div> : <div><span className='margin-right-0325' id='greyColor'><MdList className="fa-Icon" size={20} /></span>
                                                    Contract Details </div> }
                                </h4>
                            </div> :   <h4 className="bar-bottom header margin-bottom-175 detailicons">
                            <div><span className='margin-right-0325' id='greyColor'><MdList className="fa-Icon" size={20} /></span>
                                                    Contract Details </div>
                                                    </h4> }

                        {canShowForm && csbDetail.length > 0 && contract.divisionName === 'Infrastructure' ?
                            <CSBDetailsForm
                                csbDetail={csbDetail}
                                contract={contract}
                                setup={this.props.setup}
                                onSubmit={this.handleSubmit}
                                onCancel={this.toggleEditable}

                            />
                            : <ReadOnlyCSBDetails
                                contract={contract}
                            />
                        }

                        {isLoading ? <div className="loader" /> : null}
                    </div>
                    :
                    <div >
                        <h4 className="bar-bottom header margin-bottom-175 detailicons"> <span className='margin-right-0325' id='greyColor'><MdList className="fa-Icon" size={20} /></span>
                            Contract Details</h4>
                        <div className="noData">
                            No Contract Details are found for this contract.
                </div>
                    </div>}
            </div>
        );
    }
}

CSBContractDetails.propTypes = {
    csbDetail: PropTypes.array.isRequired,
    permissions: PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps) {
    return {
        csbDetail: state.additionalProjectsStore.csbDetail,
        projectId: ownProps.projectId,
        permissions: state.projectsStore.permissions,

    };
}

export default connect(mapStateToProps, { fetchCSBDetails, fetchPermissions })(CSBContractDetails);